<template>
  <div class="gallery">
    <section class = "gallery-description">
      <div class = "container">
        <logo></logo>
        <p class = "description">Esta galería incluye los proyectos de todas las convocatorias de ProgramaLaPlaza. Tambien puedes filtrar por convocatoria.</p>
        <div v-if = "true">
          <gallery-filter :searchParams = "searchParams" :categories = "['calls']" :showTitles = "false"></gallery-filter>
          <p v-if = "false">Mostrando {{galleryItems.count}} proyectos</p>
        </div>
      </div>
    </section>

    <section class = "gallery-projects">
      <div class = "container-full">
        <gallery-listing :searchParams = "searchParams" :showPaging = "true"></gallery-listing>
      </div>
    </section>
  </div>
</template>

<script>
import Logo from '@/components/UI/Logo'
import GalleryFilter from './GalleryFilter'
import GalleryListing from './GalleryListing'

export default {
  name: 'Gallery',
  components: {
    Logo,
    GalleryFilter,
    GalleryListing
  },
  props: {
  },
  data () {
    return {
      previousDisabled: true,
      nextDisabled: false,
      searchParams: {
        page: 1,
        call: '',
        tags: [],
        is_finished: true,
        is_example: false,
        is_public: true,
        codeAnalysis: {}
      }
    }
  },
  watch: {
  },
  computed: {
    numPages () {
      return this.$store.state.gallery.numPages
    },
    galleryItems () {
      return this.$store.state.gallery.fetched
    }
  },
  methods: {
  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.gallery {
  background: @backgroundColor;
  // height: 100vh;
}

.gallery-description {
  padding-top: 50px;
}

.description {
  font-size: 1.2em;
  padding: 0;
  color: #575757;
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/Gallery/Gallery.vue